import { render, staticRenderFns } from "./Disable.vue?vue&type=template&id=c9c32c50"
import script from "./Disable.vue?vue&type=script&lang=js"
export * from "./Disable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports